import { useSelector } from 'react-redux';
import { selectStatus } from '../model/slice';
import { accessControlPage } from '../model/access-control';
import { composeUser, fallbackToPathname } from '../model/utils';
import { MODULE_NAME, NO_ACCESS_URL } from '../model/constants';
import { useGetPage } from '../model/hooks';
import { getAccessMatrix, getTickets } from '../model/state';
import { STATUS_ERROR, STATUS_LOADING, STATUS_READY, STATUS_UNINITIALIZED } from '../../constants';
import { emptyArray, emptyNull, noop } from '../../../shared/misc';
import { useLocation } from 'react-router';
import { useSettings } from '../../hooks';

const AccessControlWrapper = ({
  renderElement = noop,
  renderLoading = noop,
  renderError = noop,
  page = emptyNull
}) => {
  const location = useLocation();
  const { accessControl } = page;
  const { identifier = fallbackToPathname(location) } = accessControl ?? emptyNull;
  const status = useSelector(selectStatus) ?? STATUS_UNINITIALIZED;
  const tickets = getTickets();
  const accessMatrix = getAccessMatrix();
  const getPage = useGetPage();
  const { noAccessPages = emptyArray } = useSettings(MODULE_NAME);

  if (status === STATUS_UNINITIALIZED) return renderLoading();
  if (status === STATUS_LOADING) return renderLoading();
  if (status === STATUS_ERROR) return renderError();

  const { result: hasAccess, cause } = accessControlPage(
    identifier,
    accessMatrix,
    composeUser(tickets)
  );

  if (status === STATUS_READY && hasAccess) return renderElement(page);

  const { pathname = NO_ACCESS_URL } = noAccessPages.find(({ condition }) =>
    new RegExp(condition).test(cause)
  );
  return renderElement(getPage(pathname));
};

export default AccessControlWrapper;
